export default __webpack_public_path__ + "assembly21560dc4.png";